import React from 'react';
import styled from 'styled-components';

type CarrotProps = {
  direction: string;
};

const CarrotUp = (props) => (
  <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M13 10L3 10L8 4.5L13 10Z' fill='var(--cvna-color-blue-6)'/>
  </svg>
);

const CarrotDown = styled(CarrotUp)`
  transform: rotate(180deg);
`;

const icons = {
  up: CarrotUp,
  down: CarrotDown
};

const Carrot = ({ direction }: CarrotProps) => {
  const CarrotIcon = icons[direction];
  return <CarrotIcon />;
};

export default Carrot;
